import * as React from "react";
const SvgSort = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z", fill: "#009299" }));
export default SvgSort;
